<template>
  <div style="margin: 0 5%">
    <h1 style="font-weight: bold;">来访申请</h1>
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules"
                  :style="{background:'url('+imagePath+')'}"
                  style="padding: 5%">
      <a-form-model-item label="申请人姓名" required prop="fcreater" has-feedback>
        <a-input v-model="form.fcreater" placeholder="输入申请人姓名" :disabled="fcreaterDisabled"/>
      </a-form-model-item>
      <a-form-model-item label="预约类型" required prop="ftrantype" has-feedback>
        <!--        <a-select v-model="form.ftrantype" placeholder="输入预约类型">-->
        <!--          <a-select-option value="1">公司拜访</a-select-option>-->
        <!--          <a-select-option value="2">快递送货</a-select-option>-->
        <!--          <a-select-option value="3">政府到访</a-select-option>-->
        <!--          <a-select-option value="4">快递拉货</a-select-option>-->
        <!--        </a-select>-->
        <a-select v-model="form.ftrantype">
          <a-select-option v-for="ftrantype in ftrantypes" :key="ftrantype.ftrantype">
            {{ ftrantype.ftrantname }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="到访人姓名" required prop="fname" has-feedback>
        <a-input v-model="form.fname" placeholder="输入到访人姓名"/>
      </a-form-model-item>
      <a-form-model-item label="到访人电话" required prop="fphone" has-feedback>
        <a-input v-model="form.fphone" placeholder="输入到访人电话"/>
      </a-form-model-item>
      <a-form-model-item label="到访日期" required prop="farrivetime" has-feedback>
        <a-date-picker
          v-model="form.farrivetime"
          show-time
          type="date"
          placeholder="输入预计到访日期"
          style="width: 100%;"
          :locale="locale"
          :disabled-date="disabledStartDate"
          @openChange="handleStartOpenChange"
        />
      </a-form-model-item>
      <a-form-model-item label="离开日期" required prop="fleavetime" has-feedback>
        <a-date-picker
          v-model="form.fleavetime"
          show-time
          type="date"
          placeholder="输入预计离开日期"
          style="width: 100%;"
          :locale="locale"
          :open="endOpen"
          :disabled-date="disabledEndDate"
          @openChange="handleEndOpenChange"
        />
      </a-form-model-item>

      <a-form-model-item label="车牌号">
        <!--        <span slot="label">-->
        <!--        车牌号-->
        <!--        <a-tooltip title="没有可以不填">-->
        <!--          <a-icon type="question-circle-o" />-->
        <!--        </a-tooltip>-->
        <!--      </span>-->
        <a-input v-model="form.flicenseplate" placeholder="没车不填"/>
      </a-form-model-item>
      <a-form-model-item label="到访事项" required prop="faffair" has-feedback>
        <a-input v-model="form.faffair" type="textarea" placeholder="输入到访事项"/>
      </a-form-model-item>
      <a-form-model-item label="是否带货出门" required>
        <a-radio-group name="radioGroup" v-model="form.fgoodsout" style="width: 100%">
          <a-radio :value="1">
            是
          </a-radio>
          <a-radio :value="0">
            否
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="审核人姓名" required prop="fchecker" has-feedback>
        <a-input v-model="form.fchecker" placeholder="输入审核人姓名" :disabled="fcheckerDisabled"/>
      </a-form-model-item>

      <a-form-model-item label="到访地址" required prop="flocation" has-feedback>
                <a-select v-model="form.flocation" placeholder="输入到访地址">
                  <a-select-option value="1">太仓港经济技术开发区元江路88号</a-select-option>
                  <a-select-option value="2">上海市嘉定区蕴北公路1755弄9号楼1-4</a-select-option>
                </a-select>
<!--        <a-select v-model="form.ftrantype">-->
<!--          <a-select-option v-for="ftrantype in ftrantypes" :key="ftrantype.ftrantype">-->
<!--            {{ ftrantype.ftrantname }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 12 }">
        <a-button type="primary" @click="onSubmit">
          提交
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>

</template>
<script>
import axios from "axios";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';

export default {
  name: "appointment",
  data() {
    return {
      imagePath: require('../assets/bj7.jpg'),
      locale,
      endOpen: false,
      labelCol: {span: 4},
      wrapperCol: {span: 8},
      ftrantypes: '',
      fcreaterDisabled: false,
      fcheckerDisabled: false,
      form: {
        fcreater: '',
        ftrantype: '',
        farrivetime: '',
        fleavetime: '',
        fname: '',
        fphone: '',
        flicenseplate: '',
        faffair: '',
        fgoodsout: undefined,
        fchecker: '',
        flocation:'',
      },
      rules: {
        fcreater: [
          {required: true, message: '申请人姓名不能为空', trigger: 'change'},
        ],
        ftrantype: [
          {required: true, message: '预约类型不能为空', trigger: 'change'},
        ],
        farrivetime: [
          {required: true, message: '预计到访日期不能为空', trigger: 'change'},
        ],
        fleavetime: [
          {required: true, message: '预计离开日期不能为空', trigger: 'change'},
        ],
        fname: [
          {required: true, message: '到访人姓名不能为空', trigger: 'change'},
        ],
        fphone: [
          {required: true, message: '到访人电话不能为空', trigger: 'change'},
        ],
        faffair: [
          {required: true, message: '到访事务不能为空', trigger: 'change'},
        ],
        fgoodsout: [
          {required: true, message: '是否带货不能为空', trigger: 'change'},
        ],
        fchecker: [
          {required: true, message: '审核人姓名不能为空', trigger: 'change'},
        ],
        flocatiom: [
          {required: true, message: '到访地址不能为空', trigger: 'change'},
        ],
      },
    };
  },
  computed: {
    // computeFcreater: function () {
    //   return this.form.fcreater==''?"error":"success";
    // },
  },
  mounted() {
    // alert(this.$route.query.code);
    axios.all([
      // axios.get("http://www.tcnanhua.com:5555/user/getUserName?code=" + this.$route.query.code),
      // // .then((res) => {
      // //   this.form.fcreater = res.data.data;
      // // }),
      axios.get("http://www.tcnanhua.com:5555/user/getNameAndSuperior?code=" + this.$route.query.code),
      // .then((res) => {
      //   this.form.fchecker = res.data.data;
      // }),
      axios.get("http://www.tcnanhua.com:5555/t-nh-appointmenttype/selectAll")
      // .then((res) => {
      //   this.ftrantypes = res.data.data;
      // })
    ]).then(axios.spread((res1, res2) => {
      let resJson = JSON.parse(res1.data.data);
      this.form.fcreater = resJson.userName;
      this.form.fchecker = resJson.superior;
      this.ftrantypes = res2.data.data;
      if (this.form.fcreater != null && this.form.fcreater != "" && this.form.fcreater != undefined) {
        this.fcreaterDisabled = true;
      }
      if (this.form.fchecker != null && this.form.fchecker != "" && this.form.fchecker != undefined) {
        this.fcheckerDisabled = true;
      }
    }))
  },

  methods: {
    onSubmit() {
      this.$message.loading('提交中...');
      if (this.form.fcreater == "") {
        alert("申请人必填");
        return;
      }
      if (this.form.ftrantype == "") {
        alert("预约类型必填");
        return;
      }
      if (this.form.farrivetime == undefined) {
        alert("预计到访日期必填");
        return;
      }
      if (this.form.fleavetime == undefined) {
        alert("预计离开日期必填");
        return;
      }
      if (this.form.farrivetime > this.form.fleavetime || this.form.farrivetime < new Date() || this.form.fleavetime < new Date()) {
        alert("时间信息不合法");
        return;
      }
      if (this.form.fname == "") {
        alert("到访人姓名必填");
        return;
      }
      if (this.form.fphone == "") {
        alert("到访人电话必填");
        return;
      }
      if (this.form.faffair == "") {
        alert("到访事务必填");
        return;
      }
      if (this.form.fgoodsout == undefined) {
        alert("是否带货必填");
        return;
      }
      if (this.form.fchecker == "") {
        alert("审核人必填");
        return;
      }
      if (this.form.flocation == "") {
        alert("到访地址必填");
        return;
      }
      axios.get("http://www.tcnanhua.com:5555/t-nh-appointment/insert?fcreater=" + this.form.fcreater + "&ftrantype=" + this.form.ftrantype
        + "&farrivetime=" + this.form.farrivetime + "&fleavetime=" + this.form.fleavetime + "&fname=" + this.form.fname + "&fphone=" + this.form.fphone
        + "&flicenseplate=" + this.form.flicenseplate + "&faffair=" + this.form.faffair + "&fgoodsout=" + this.form.fgoodsout
        + "&fchecker=" + this.form.fchecker+ "&flocation=" + this.form.flocation)
        .then((resp) => {
          this.code = resp.data.code;
          if (this.code == 1) {
            this.$message.success('提交成功,页面即将关闭,若未关闭请手动关闭');
          } else {
            this.$message.error('提交审核失败,请稍后再试,页面即将关闭,若未关闭请手动关闭');
          }
        });
      setTimeout(function () {
        window.opener = null;
        window.open("about:blank", "_top").close();
      }, 3000);
    },
    moment,
    disabledStartDate(current) {
      // 大于当前日期不能选 time > moment()
      // 小于当前日期不能选 time < moment().subtract(1, "day")
      // 只能选前7后7 time < moment().subtract(7, "day") || time > moment().add(7, "day")
      //return current && current < moment().endOf("day");！！！！！当天之前的不可选，包括当天
      // return current < moment().subtract(1, "day") ！！！！！当天之前的不可选，不包括当天
      return current < moment();
    },
    disabledEndDate(endValue) {
      const startValue = this.form.farrivetime;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
  },
};
</script>


<style>
label {
  margin-right: 10%;
}

</style>



// WEBPACK FOOTER //
// src/components/Appointment.vue